import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { useScreenGo } from '@gogame/screens';

import { useViewStateByPath } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

const Guard = ({ path, children }) => {
  const values = useViewStateByPath(path);
  const go = useScreenGo();

  React.useEffect(() => {
    if (isEmpty(values)) {
      go('..');
    }
  }, [values]);

  return values ? children : null;
};

export default Guard;
